"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// import PropTypes from 'prop-types';
var CountriesSection_1 = require("./CountriesSection");
var CompanyInfoSection_1 = require("./CompanyInfoSection");
var TreeSelector_1 = require("./TreeSelector");
var styles_1 = require("./styles");
var APMetaDataForm = /** @class */ (function (_super) {
    __extends(APMetaDataForm, _super);
    function APMetaDataForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            updatedGeographies: null,
            exportedMetadata: _this.props.exportedMetadata,
        };
        _this.handleChange = function (data) {
            var exportedMetadata = _this.state.exportedMetadata;
            _this.setState({
                exportedMetadata: __assign({}, exportedMetadata, data),
            }, _this.triggerOnChange);
        };
        _this.handleChangeGeo = function (_a) {
            var value = _a.target.value;
            _this.setState({
                updatedGeographies: value,
            }, _this.triggerOnChange);
        };
        _this.triggerOnChange = function () {
            var metadataOptions = _this.props.metadataOptions;
            var _a = _this.state, updatedGeographies = _a.updatedGeographies, _b = _a.exportedMetadata, geographiesState = _b.geographies, exportedMetadataState = __rest(_b, ["geographies"]);
            var geographies = updatedGeographies || _this.getSelectedGeographies(geographiesState);
            var processedExportedMetadata = {};
            Object.entries(exportedMetadataState)
                .filter(function (_a) {
                var _0 = _a[0], value = _a[1];
                return value && value.data;
            })
                .forEach(function (_a) {
                var key = _a[0], value = _a[1];
                processedExportedMetadata[key] = __assign({}, value);
            });
            var exportedMetadata = __assign({}, processedExportedMetadata, { geographies: {
                    data: geographies.map(function (item) {
                        return TreeSelector_1.getItemByCode(metadataOptions.geographies.data || [], item);
                    }) || [],
                    version: metadataOptions.geographies.version,
                } });
            _this.props.onChange({
                isFormValid: _this.validateExportedMetadata(exportedMetadata),
                exportedMetadata: exportedMetadata,
            });
        };
        _this.validateExportedMetadata = function (exportedMetadata) {
            var geographies = exportedMetadata.geographies, data = __rest(exportedMetadata, ["geographies"]);
            var isValid = geographies.data &&
                geographies.data.length > 0 &&
                Object.entries(data).length === 4 &&
                !!Object.entries(data).every(function (_a) {
                    var _0 = _a[0], value = _a[1];
                    return value.data && value.data.key;
                });
            return isValid;
        };
        _this.getParsedGeographies = function (metadataOptions) {
            return TreeSelector_1.parse(metadataOptions.geographies ? metadataOptions.geographies.data : []);
        };
        _this.getSelectedGeographies = function (geographies) {
            return geographies && geographies.data
                ? geographies.data.map(function (item) {
                    return TreeSelector_1.getCodeFromItem(item).id;
                })
                : [];
        };
        return _this;
    }
    APMetaDataForm.prototype.render = function () {
        var _a = this.state, exportedMetadata = _a.exportedMetadata, updatedGeographies = _a.updatedGeographies;
        var metadataOptions = this.props.metadataOptions;
        this.parsedGeographies =
            this.parsedGeographies || this.getParsedGeographies(metadataOptions);
        var selectedGeographies = updatedGeographies ||
            this.getSelectedGeographies(exportedMetadata.geographies);
        return (react_1.default.createElement(styles_1.Form, null,
            react_1.default.createElement(styles_1.FormHeader, null,
                react_1.default.createElement(styles_1.FormTitle, null, "Knowledge Base Metadata"),
                react_1.default.createElement(styles_1.FormDescription, null,
                    react_1.default.createElement("p", null,
                        "The below fields will be appended to any data you choose to export to the Knowledge Base for permanent storage and analysis by AlixPartners.",
                        ' '),
                    react_1.default.createElement("p", null, "Record the details for the business unit your engagement is with, not the parent organisation. You must complete all fields."))),
            react_1.default.createElement(CompanyInfoSection_1.CompanyInfoSection, { animationIndex: 1, metadataOptions: metadataOptions, exportedMetadata: exportedMetadata, onChange: this.handleChange }),
            react_1.default.createElement(CountriesSection_1.CountriesSection, { animationIndex: 2, data: this.parsedGeographies, value: selectedGeographies, onChange: this.handleChangeGeo })));
    };
    return APMetaDataForm;
}(react_1.Component));
exports.APMetaDataForm = APMetaDataForm;
//# sourceMappingURL=APMetaDataForm.js.map